"use strict";

import React from 'react';

const PasswordError = ({error={}}) => {
    if(!!error && !!error.type){
        return (
            <small className="form__error">
                {error.type === 'required' && 'A valid password is required.' }
                {error.type === 'minLength' && 'Your password must be at least 8 characters long.' }
                {error.type === 'maxLength' && 'Your password needs to be shorter than 50 characters long.' }
                {error.type === 'asyncValidation' && (error.message || ' Invalid password') }
            </small>
        );
    }
    else
        return null;

};

export default PasswordError;
